

import { createApp } from 'vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { VueGtm } from '@gtm-support/vue-gtm';
import { VueGtag } from "vue-gtag";
import App from './App.vue'
import {capitalize, lowerCase, upperCase, formatDate, formatCurrency} from './filters/index';
import i18n from './i18n';


const app = createApp(App);
app.use(router);
app.use(vuetify);
app.use(i18n);

//globalProperties
app.config.globalProperties.$filters = {
  capitalize, lowerCase, upperCase, formatDate, formatCurrency
}

// Set title based on translation
const updateDocumentTitle = () => {
  document.title = i18n.global.t('translation.metaTitle') || 'AIT Home Delivery UK Ltd Tracker'; // Fallback
};

// Update títle
updateDocumentTitle();

if(process.env.VUE_APP_ENABLE_GOOGLE_TAG_MANAGER === 'true')
{
  //console.log('GTM Enabled',process.env.VUE_APP_ENABLE_GOOGLE_TAG_MANAGER);
  app.use(VueGtm, {
    id: process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    nonce: '2726c7f26c', // Will add `nonce` to the script tag
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  });
}

if(process.env.VUE_APP_ENABLE_GOOGLE_ANALYTICS === 'true')
{
  //console.log('GA Enabled',process.env.VUE_APP_ENABLE_GOOGLE_ANALYTICS);
  app.use(VueGtag, {
    config: { 
      id: process.env.VUE_APP_GA_MESUREMENT_ID
    }
   }, router); 
  
}

app.mount('#app')
